import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    SelectInput,
    EditButton,
    ShowButton,
    DeleteButton,
    Show,
    SimpleShowLayout,
    
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import ErrorBoundary from '../ErrorBoundary';

let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
})




const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
}; 

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const SamplesFilter = props => (
    <Filter {...props}>
        <SearchInput source="box_num" alwaysOn  />
        <DateInput source="bleed_date" label="Bleed date"  locales="en-us"/>
        <DateField source="ship_date" label="Shipping date"  locales="en-us"/>
        <TextInput source="cu_numbers" lable="Unit Control Number" />
        <TextField source="test_mode" label="Test Type"/>
    </Filter>
);

const CanDelete=({ record, resource, id, onToggleItem, children, selected, basePath})=>{
    const DeleteTitle = (({ record }) => <span>
    {'Delete '}
    {record && `${record.box_num} ${record.test_mode}`}
    </span>);
    return (record.exported === 0)?<DeleteButton title={<DeleteTitle />}  
                                                 undoable={false} 
                                                 label='Delete'  
                                                 record={record} 
                                                 basePath={`/samples?filter=%7B"branch_code"%3A"${branch_code}"%7D&order=DESC&page=1&perPage=25`} 
                                                 resource={resource}/> : '';
}

const CanEdit=({ record, resource, id, onToggleItem, children, selected, basePath})=>{
 
    return (record.exported === 0)?<EditButton  label='Edit'  record={record} basePath={basePath} resource={resource}/> : '';
}


const SSNS=({record})=>{
    var ssns = record && record.isextra? JSON.parse(record.cu_numbers).map((controNum)=>`${controNum.SSN + ', '}`): null;
    return(
        <span>SSNs: {ssns}</span>
    )

}
const ControlNumber=({record})=>{
   
    //var num = record && record.isextra? JSON.parse(record.cu_numbers).map((controNum)=>`${controNum.UCN + ', '}`)    : record? record.cu_numbers: '';
    var ucns =  record && record.cu_numbers? (record.cu_numbers).split(';').map(cun=>(cun.split(',')[0])): ''
    
    return(
        <div>
            <span>Control Unit Numbers: {ucns}</span><br/>
            {//record.isextra && <SSNS  recored={record} />
            }
        </div>
    )
}

const UnitsShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
            <ControlNumber />
            <TextField source="time_removed" label= "Time Removed from Storage for Shipment"  />
            <TextField source="init" label= "initial"  /> 
            <DateField  source="init_date" label='Date'  />
            <TextField source="location" label= "Location"  /> 
        </SimpleShowLayout>
    </Show>
);

const ShowDetails = ({record}) => {
    const classes = useStyles();
    var ucns =  record && record.cu_numbers? (record.cu_numbers).split(';').map(cun=>(`${cun }`)): ''
    //var ssns =  record && record.cu_numbers? (record.cu_numbers).split(';').map(cun=>(`${cun.split(',')[1] + ','}`)): ''
    return(
        <div className={classes.root}>
       
        
            {record.test_mode !=='NAT'&& <span><b>Unit Control Numbers: </b>{ucns} </span>}
            {record.test_mode ==='NAT'&& 
            <div>
                 <span><b>Begining Unit Control Numbers: </b>{record ? record.s_ucn: ''} </span>
                 <br />
                 <span><b>Ending Unit Control Numbers: </b>{record ? record.e_ucn: ''} </span>
            </div>
            }
            <br />
                 <span><b>Total: </b>{record ? record.total: ''} </span>
            <br />
            <span><b>Time Removed from Storage for Shipment: </b> {record ? `${record.time_removed}` : ''} </span>
            <br />
            <span><b>Initial: </b> {record ? `${record.init }`   : ''} </span>
            <br />
            <span><b>Date: </b>  {record ?`${moment(record.init_date).format('MM-DD-yyy')}` : '' } </span>
            <br />
            <span><b>Location: </b> {record ? `${record.location }`   : ''} </span>

            
        </div>
    )
}

export const SamplesList = ({ classes, permissions, ...props }) => (
<ErrorBoundary>  
    <List 
        {...props}
        classes={classes}
        filters={<SamplesFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        >
        <Datagrid  >
            <TextField source="box_num" label="Box#" />     
            <TextField source="test_mode" label="Type"/>
            <DateField source="bleed_date" label="Bleed"  locales="en-us"/>
            <DateField source="ship_date" label="Shipping"  locales="en-us"/>
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 2  && <ShowButton label='View' />}
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 2  && <CanEdit  />}
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 2  && <CanDelete  /> }
        </Datagrid>
    </List>
</ErrorBoundary>  
);


export default SamplesList